import React, { useEffect, useState } from 'react';
import { useDispatch , useSelector } from 'react-redux';

// TS types
import {
    IListProps,
    scrollToRef,
    ICalendar,
    ITHSRInfoData,
} from '@redux/common';
//Redux
import { RootState } from '@redux/store';

// import module
// component
// shared component
// common function
import {
    initTicketNum,
    convertTicketNum,
    decodeHTMLstring,
    addSeparator,
    getEarliestDate,
    getLatestDate
} from '@libs/core';
import { isMobile } from '@libs/globalVariables';
import { fetchDetailData, fetchNextMonthData } from '@libs/apiCall';

// plugin
import cx from 'classnames';
import dayjs from 'dayjs';
import minMax from 'dayjs/plugin/minMax';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { useTranslation } from 'react-i18next';

// redux actions
import {
    setTCalendarErrorMsg,
    setTSessionErrorMsg,
    setTTicketErrorMsg,
    setTSubmitErrMsg,
    setTMInfoShow,
    setTNowListID,
    setTNowListData,
    setTPickCalendar,
    setTTicketNum,
    setTAllSessions,
    setTPickSession,
    setTTotalAmount,
    setSalePriceSpread,
    setShowCrossellTag,
    setTDetailLoadingFail,
    setTDetailData,
    setTTempCalendarData,
    setTIsDetailLoading,
    setTIsSessionLoading,
    setTSessionLoadingFail,
    setTScollTo,
    setTETItemData,
    setTMinDate,
    setTNullDate,
    setTDisabledDate,
    setTSoldoutDate,
    setTDisabledDateBySession,
    setTRestore,
} from '@redux/NormalT/actions';
import { setIsTDetailCrossLoading, setDetailFetchAllData, setDetailFetchMonths, setDetailFetchFailMsg } from '@redux/Common/actions';

const TPlan: React.FC<IListProps> = (props) => {
    dayjs.extend(minMax);
    dayjs.extend(isSameOrAfter);
    dayjs.extend(isSameOrBefore);
    const dispatch = useDispatch();
    const {
        FormatID,
        FormatName,
        LowListPrice,
        LowSalePrice,
        EarliestBuyDay,
        IntroductionArray,
        ExpectedUseDay,
        IsForSale,
        NotForSaleReason,
    } = props.data;
    const { Currency, SaleCurrency, listIndex, changeTotalIsInStock, isCrossell} = props;
    const { t } = useTranslation();
    const {
        NowListID,
        NowListData,
        DetailData,
        ticketNum,
        allSessions,
        ETItemData,
        pickCalendar,
        pickSession,
        isSubmitSuccess,
        MInfoShow,
        isDetailLoading,
        isSessionLoading,
        TfinalAbleDates,
        calendarErrorMsg,
        sessionErrorMsg,
        ticketErrorMsg,
        SubmitErrMsg
    } = useSelector((state: RootState) => state.NormalT);
    const { 
        isLogin, 
        ListData,
        DetailFetchAllData, 
        ETID, 
        Foreign, 
        isTDetailCrossLoading, 
        DetailFetchMonths 
    } = useSelector((state: RootState) => state.Common);
    const { THSRInfo, THSRSearchOption } = useSelector((state: RootState) => state.THSR);
    // const [filterData, setFilterData] = useState<IFilterData>(null); //可篩選資料
    // const [filterDate, setFilterDate] = useState<{}[]>(null);
    const { ProductUseDate }: ITHSRInfoData = THSRInfo;
    const hasCalendar = NowListData?.ExpectedUseDay;
    const hasSession = DetailData?.Sessions;
    
    // 更新ETITEM & 初始化場次(TODO:第三階段改成打場次API)
    useEffect(() => {
        if (!DetailData) return;
        console.log("更新ETITEM&初始化場次🐱-- DetailData",DetailData)

        // 更新ETITEM
        if (ExpectedUseDay) {
            //沒場次的直接設定選取日的ETITEM，有場次的在setSession後，會在TicketBlock裡抓值重新render [事件1]
            // if (!DetailData?.Sessions) { 
            //     Object.keys(DetailData.CalendarDate).length !== 0
            //     ? dispatch(setTicketNum(convertTicketNum(DetailData.CalendarDate[pickCalendar]?.ETItem)))
            //     : dispatch(setTicketNum(convertTicketNum(DetailData.ETItem)))
            // }
            /*-----自建第一階段使用 (TODO: 改完場次用上面的)------*/
                console.log("DetailData影響更新ETITEM START")
                Object.keys(DetailData.CalendarDate).length !== 0
                    ? dispatch(setTTicketNum(convertTicketNum(DetailData.CalendarDate?.[pickCalendar]?.ETItem)))
                    : dispatch(setTTicketNum(convertTicketNum(DetailData.ETItem)))
            /*------------------------------------*/
        } else {
            dispatch(setTTicketNum(convertTicketNum(DetailData?.ETItem)));
        }

        //初始化當月場次資料(自建第一、二階段用)
        const initialSessionData = (CalendarDate: ICalendar) => {
            let firstDay = getEarliestDate(Object.keys(CalendarDate)) // 抓可選日期的第一天
            let sessions = CalendarDate[firstDay].Events

            if (sessions.length > 0) {
                dispatch(setTAllSessions(sessions))
                dispatch(setTPickSession(sessions[0])) //預設選定第一筆session
            };
        };
        if (
            hasSession &&
            Object.keys(DetailData.CalendarDate).length !== 0
        ) initialSessionData(DetailData.CalendarDate)

        dispatch(setTIsDetailLoading(false));

    }, [DetailData]);

    // --------因高鐵選擇日期可能是跨月份，因此要判斷是否fetch跨月份資料START-------
    /** **跨月模擬 SAMPLE**
     *            票月    高鐵月
        ----1_1
        開始        4       5
        結束        6       5
        ----1_2 TODO: 不同月下是甚麼狀況??
        開始        3       5
        結束        5       ??
        ----2
        開始        4       5
        結束        7       6
        ----3
        開始        4       4
        結束        6       5
     * 
    */
    useEffect(() => {
        if (!hasCalendar || DetailData == null) return;

        const handleFetchNewData = async () => {
            const useDateStart = dayjs(getEarliestDate(ProductUseDate));
            const useDateEnd = dayjs(getLatestDate(ProductUseDate));
            const calendarStart = dayjs(getEarliestDate(Object.keys(DetailData.CalendarDate)));
            const calendarEnd = dayjs(DetailData.LastBuyDay);
            const isTHSRSameMonth = useDateStart.isSame(useDateEnd, 'month');
            const DetailDataCopy = JSON.parse(JSON.stringify(DetailData));
            const fetchData:any = {};
            //判斷是否打過API，並已經合併為完整資料(for condition3 狀況)
            const storedLastMonthData = dayjs(getLatestDate(Object.keys(DetailData.CalendarDate)));

            // 高鐵限制票券最晚使用月 早於 票券原始最早使用月
            if (useDateEnd.isBefore(calendarStart, 'month')) return;

            // 高鐵限制票券最早使用月 晚於 票券原始最晚使用月
            if (useDateStart.isAfter(calendarEnd, 'month')) return;

            // 本地有的最晚月資料 === 高鐵選擇的最晚月資料(防止第二次重打)
            if(storedLastMonthData.isSame(useDateEnd, 'month')) return;

            // 以下"高鐵"代表經高鐵規則限制後的票券可使用日期，"票券"則為原始票券可使用日期
            // ----------高鐵起訖同個月-------
            // 需要fetch高鐵最早月
            // 票券最早月 < 高鐵最早月 && 票券最晚月 >= 高鐵最早月
            const condition1_1 =
                isTHSRSameMonth &&
                calendarStart.isBefore(useDateStart, 'month') &&
                calendarEnd.isSameOrAfter(useDateStart, 'month');

            // ----------高鐵起訖不同月----------
            // 需fetch高鐵最早月
            // 票券最早月 < 高鐵最早月 && 票券最晚月 === 高鐵最早月 TODO: 起訖不同月下會有這種狀況??
            const condition1_2 =
                !isTHSRSameMonth &&
                calendarStart.isBefore(useDateStart, 'month') &&
                calendarEnd.isSame(useDateStart, 'month');

            // 需fetch高鐵最早與最晚月，共兩個月
            // 票券最早月 < 高鐵最早月 && 票券最晚月 > 高鐵最晚月
            const condition2 =
                !isTHSRSameMonth &&
                calendarStart.isBefore(useDateStart, 'month') &&
                calendarEnd.isAfter(useDateStart, 'month');

            // 需fetch高鐵最晚月
            // 票券最早月 === 高鐵最早月 && 票券最晚月 >= 高鐵最晚月
            const condition3 =
                !isTHSRSameMonth &&
                calendarStart.isSame(useDateStart, 'month') &&
                calendarEnd.isSameOrAfter(useDateStart, 'month');

            // 無符合任何條件代表不需要去打票券新月份資料
            if (!condition1_1 && !condition1_2 && !condition2 && !condition3) return;

            // ------------以上為所有判斷是否要進行fetch new data--------------------
            dispatch(setIsTDetailCrossLoading(true));

            if (condition1_1 || condition1_2) {
                // console.log('fetch高鐵最早月', condition1_1, condition1_2);
                const firstFetch = await fetchNextMonthData({
                    CalenderMonth: useDateStart.format('YYYY-MM'),
                    ETID,
                    FormatID,
                    ThsrRoundType:THSRSearchOption.THSRType
                });
                const firstData = await firstFetch.json();
                // 因為目前是抓CalendarDate裡的第一天做calendarStart設定，所以不能融合原本票卷的月份資料(會無限重打)
                Object.assign(fetchData, firstData);
            }
            if (condition2) {
                // console.log('fetch高鐵最早月與最晚月');
                const firstFetch = await fetchNextMonthData({
                    CalenderMonth: useDateStart.format('YYYY-MM'),
                    ETID,
                    FormatID,
                    ThsrRoundType:THSRSearchOption.THSRType
                });
                const secondFetch = await fetchNextMonthData({
                    CalenderMonth: useDateEnd.format('YYYY-MM'),
                    ETID,
                    FormatID,
                    ThsrRoundType:THSRSearchOption.THSRType
                });
                const firstData = await firstFetch.json();
                const secondData = await secondFetch.json();

                let newCalendarData = Object.assign(
                    {},
                    firstData?.CalendarDate,
                    secondData?.CalendarDate
                );

                const newDetailData = {
                    ...secondData, // 因為返回屬性都相同(同個detail API)，所以只要抓其中一個合併就好
                    CalendarDate: newCalendarData, // 覆蓋成兩個月的資料
                };
                Object.assign(fetchData, newDetailData);
            }
            if (condition3) {
                // console.log('fetch高鐵最晚月');
                const firstFetch = await fetchNextMonthData({
                    CalenderMonth: useDateEnd.format('YYYY-MM'),
                    ETID,
                    FormatID,
                    ThsrRoundType:THSRSearchOption.THSRType
                });
                const firstData = await firstFetch.json();
                let newCalendarData = Object.assign(
                    DetailDataCopy?.CalendarDate || {},
                    firstData?.CalendarDate
                );
                const newDetailData = {
                    ...firstData,
                    CalendarDate: newCalendarData, // 覆蓋成兩個月的資料
                };
                Object.assign(fetchData, newDetailData);
            }
            dispatch(setTDetailData(fetchData));
            dispatch(setTTempCalendarData(fetchData?.CalendarDate));
            dispatch(setIsTDetailCrossLoading(false));
        };

        handleFetchNewData();
    }, [ProductUseDate, DetailData]);
    // --------因高鐵選擇日期可能是跨月份，因此要判斷是否fetch跨月份資料END-------
   
    /** 
    * [日庫存]目前在 
    * 1.更換月份及跨月機制(更新detailData)
    * 2.點選日期
    * 都會更新 TicketNum
    * TODO: 之後場次API完成後檢查，沒問題就刪除
    */
    //01/13 IT提出[日庫存]：如果該產品為有月曆的產品，當所選日期有變動時，要更新篩選資料
    // useEffect(() => {
    //     if (DetailData?.CalendarDate) {
    //         let ETItem = pickCalendar
    //             ? DetailData?.CalendarDate[pickCalendar]
    //                 ? DetailData?.CalendarDate[pickCalendar].ETItem
    //                 : DetailData.ETItem
    //             : DetailData.ETItem;
    //         let newTicketNum = { ...ticketNum };
    //         ETItem.forEach((element) => {
    //             if (newTicketNum[element.ItemSeq] > element.HighQty) {
    //                 newTicketNum[element.ItemSeq] = element.HighQty;
    //             }
    //         });
    //         ticketNum && dispatch(setTTicketNum(newTicketNum));
    //     }
    // }, [pickCalendar]);

    /*===========================根據選取條件篩選資料=======================*/
        //點選票券數量後的篩選
        // useEffect(() => {
        //     if (!hasCalendar) return; //如果是沒月曆的產品則不用進行篩選
        //     if (ticketNum && filterData) {
        //         let keys = Object.keys(ticketNum);
        //         let filterDates = [];
        //         filterDates = keys.map((itemSeq) => {
        //             //用票券數量篩選出各票券可使用日期及場次
        //             return filterData[itemSeq][ticketNum[itemSeq]];
        //         });
        //         let _disabledDate = []; //用票券數量篩選出各票券不可使用日期及場次
        //         filterDates.forEach((itemSeq) => {
        //             _disabledDate = [
        //                 ..._disabledDate,
        //                 ...availableDate.current.filter((date) => !Object.keys(itemSeq).includes(date)),
        //             ];
        //         });
        //         setFilterDate(filterDates);
        //         _disabledDate = Array.from(new Set(_disabledDate));
        //         dispatch(setDisabledDate(_disabledDate));
        //     }
        // }, [ticketNum, DetailData, filterData]);
        // //點選日期或場次後的篩選
        // useEffect(() => {
        //     if (!hasCalendar) return; //如果是沒月曆的產品則不用進行篩選
        //     if (!pickCalendar && !pickSession) {
        //         //無選取日期及場次
        //         dispatch(setDisabledDateBySession([]));
        //         dispatch(setDisabledSessions([]));
        //         dispatch(setETItemData(ETItem));
        //     } else if (!pickCalendar && pickSession) {
        //         //無選取日期但有場次
        //         let _disabledDateBySession = [];
        //         filterDate.forEach((item) => {
        //             _disabledDateBySession = Array.from(
        //                 new Set([
        //                     ..._disabledDateBySession,
        //                     ...Object.keys(item).filter((date) => {
        //                         return !item[date].includes(pickSession);
        //                     }),
        //                 ])
        //             );
        //         });
        //         dispatch(setDisabledSessions([]));
        //         dispatch(setDisabledDateBySession(_disabledDateBySession));
        //         dispatch(setETItemData(ETItem));
        //     } else if (pickCalendar && !pickSession) {
        //         //有選取日期,但未選取場次
        //         dispatch(setETItemData(DetailData.CalendarDate[pickCalendar].ETItem));
        //         let disabledSessions = allSessions?.filter(
        //             (session) => !DetailData.CalendarDate[pickCalendar].Events.includes(session)
        //         );
        //         dispatch(setDisabledDateBySession([]));
        //         dispatch(setDisabledSessions(disabledSessions));
        //     } else {
        //         let _disabledDateBySession = [];
        //         filterDate.forEach((item) => {
        //             _disabledDateBySession = Array.from(
        //                 new Set([
        //                     ..._disabledDateBySession,
        //                     ...Object.keys(item).filter((date) => {
        //                         return !item[date].includes(pickSession);
        //                     }),
        //                 ])
        //             );
        //         });
        //         dispatch(setDisabledDateBySession(_disabledDateBySession));
        //         let disabledSessions = allSessions?.filter(
        //             (session) => !DetailData.CalendarDate[pickCalendar].Events.includes(session)
        //         );
        //         dispatch(setDisabledSessions(disabledSessions));
        //         dispatch(setETItemData(DetailData.CalendarDate[pickCalendar].ETItem));
        //     }
        // }, [pickCalendar, pickSession, filterDate]);
    /*==============================================================*/
    
    // 更新加總價格
    useEffect(() => {
        // 加總
        const calculateAmount = (clickedData: string) => {
            // TODO: 因sonarQube會擋邏輯，所以待IT開發完Session API，在做調整
            // const ETdata = ExpectedUseDay
            //     ? hasSession
            //         // ? getSessionInfo({ session, sessionPicked })?.ETItem 
            //         ? DetailData.CalendarDate[clickedData]?.ETItem //TODO: 第三階段廢除，用上面的
            //         : DetailData.CalendarDate[clickedData]?.ETItem
            //     : DetailData.ETItem;

            const ETdata = ExpectedUseDay
                ? DetailData.CalendarDate[clickedData]?.ETItem
                : DetailData.ETItem;
            if (!ETdata) return 0;

            const hasSalePriceSpread = ETdata.some(item => item.SalePrice_Spread > 0);
            dispatch(setShowCrossellTag(hasSalePriceSpread));

            let totalAmount = 0;
            let totalSpread = 0;
            const keys = Object.keys(ticketNum);

            if(isLogin){
                keys.forEach((key) => {
                    let obj = ETdata.find((item) => item.ItemSeq === key);
                    if (!obj) return [];
                    if (obj) {
                        let price = obj.SalePrice !== 0 ? obj.SalePrice : obj.SalePrice_NonMember;
                        if (isCrossell) {
                            totalSpread += ticketNum[key] * obj.SalePrice_Spread;
                            price -= obj.SalePrice_Spread;
                        }
                        totalAmount += ticketNum[key] * price;
                    }
                });
            } else {
                keys.forEach((key) => {
                    let obj = ETdata.find((item) => item.ItemSeq === key);
                    if (!obj) return [];
                    if (obj) {
                        let price = obj.SalePrice_NonMember;
                        if (isCrossell) {
                            totalSpread += ticketNum[key] * obj.SalePrice_Spread;
                            price -= obj.SalePrice_Spread;
                        } else {
                        }
                        totalAmount += ticketNum[key] * price;
                    }
                });
            }
            dispatch(setSalePriceSpread(totalSpread));
            return totalAmount;
        };

        if (ticketNum) {
            const amount = calculateAmount(pickCalendar);
            dispatch(setTTotalAmount(addSeparator(amount)));
            if (amount > 0) dispatch(setTTicketErrorMsg(''));
        }else{
            dispatch(setTTotalAmount('0'));
        }
    }, [ticketNum, isCrossell]);

    // 清單牌價顯示規則
    const ShouldOriginPriceShow = (() => {
        if (LowListPrice === 0) return false;
        if (!LowListPrice) return false;
        switch (Foreign) {
            case '0':
                if (LowSalePrice > LowListPrice) return false;
                if (LowSalePrice === LowListPrice) return false;
                break;
            case '1':
            default:
                return true;
        }
        return true;
    })();

    //選擇左側品項 
    const handleClickList = () => {
        if (NowListID !== FormatID) {
            /*
            // 2023/04/11 與IT討論，決定改成切換月份都會重打，並且detail API -> EarliestBuyDay改成固定
            // 若為多品項產品，切換品項後要先刪除該品項之前打過的月份紀錄
            const copyDetailFetchMonths = {...DetailFetchMonths}
            const existID = Object.keys(copyDetailFetchMonths).find((saveID)=> saveID === FormatID)
            if(existID){
                copyDetailFetchMonths[existID] = []
                dispatch(setDetailFetchMonths(copyDetailFetchMonths))
            }
            */
            const fetchDetailProps = {
                ETID,
                EarliestBuyDay,
                ExpectedUseDay,
                FormatID,
                isTHSR: true,
                // DetailFetchMonths: copyDetailFetchMonths,
                context: {
                    DetailFetchAllData,
                    setDetailFetchAllData,
                    setDetailLoadingFail: setTDetailLoadingFail,
                    setDetailFetchFailMsg,
                    setDetailData: setTDetailData,
                    setTempCalendarData: setTTempCalendarData,
                    setIsDetailLoading: setTIsDetailLoading,
                    setPickCalendar: setTPickCalendar,
                    // setDetailFetchMonths,
                    ThsrRoundType: THSRSearchOption.THSRType,  
                    // TODO:第二階段處理
                    setIsSessionLoading: setTIsSessionLoading,
                    setSessionLoadingFail: setTSessionLoadingFail,
                    setAllSessions: setTAllSessions,
                    setPickSession: setTPickSession
                },
                dispatch,
            };
            calendarErrorMsg && dispatch(setTCalendarErrorMsg(''));
            sessionErrorMsg && dispatch(setTSessionErrorMsg(''));
            ticketErrorMsg && dispatch(setTTicketErrorMsg(''));
            SubmitErrMsg && dispatch(setTSubmitErrMsg(''));

            dispatch(setTPickCalendar(getEarliestDate(TfinalAbleDates)));
            fetchDetailData(fetchDetailProps);
            dispatch(setTNowListData(props.data));
            dispatch(setTNowListID(FormatID));
        }
    };

    const handleScrollTo = () => {
        if (!isMobile) return;
        if (hasCalendar) {
            dispatch(setTScollTo(scrollToRef.calender));
        } else {
            dispatch(setTScollTo(scrollToRef.ticket));
        }
    };

    // 自建M版 取得當前品項並更改TotalIsInStock狀態
    useEffect(() => {
        changeTotalIsInStock(IsForSale)
        console.log("執行changeTotalIsInStock")
    },[FormatID]);

    return (
        <div
            className={cx('Tplan', 'normalTHSR', {
                active: NowListID === FormatID,
                disabled: (ExpectedUseDay && !EarliestBuyDay) || !IsForSale,
            })}
            data-index={listIndex}
            onClick={(e) => {
                e.stopPropagation();
                if(isDetailLoading || isSessionLoading ) return;
                handleClickList();
                handleScrollTo();
            }}
        >
            <div className="showInfo">
                <div className="leftPart">
                    <div className="title">{FormatName}</div>
                    {/* {IntroductionArray && (
                        <div className="notice_wrap">
                            <ul className="notice">
                                {IntroductionArray?.map((notice, i) => {
                                    const htmlStr = decodeHTMLstring(notice);
                                    return (
                                        <li key={i}>
                                            <span
                                                dangerouslySetInnerHTML={{ __html: htmlStr }}
                                            ></span>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    )} */}
                </div>
                <div className="rightPart">
                    <div className="titleBlock">
                        <div className="title">{FormatName}</div>
                    </div>
                    <div className="pickBlock">
                        <div className="price">
                            {
                                ((ExpectedUseDay && !EarliestBuyDay) || !IsForSale ) 
                                ? 
                                <div className="soldOut">
                                    <span>{NotForSaleReason}</span>
                                </div>
                                :   
                                <>
                                    <div className="sale">
                                        <span className="saleCurrency">{SaleCurrency}</span>
                                        <span className="salePrice">{addSeparator(
                                            FormatID === "Default" 
                                            ? ListData.TotalLowSalePrice
                                            : LowSalePrice
                                        )}</span>
                                        <span className="priceLabel">{t('THSR.plan.up')}</span>
                                    </div>
                                    {/* 高鐵面板一樣有原價顯示機制 */}
                                    {ShouldOriginPriceShow && (
                                        <div className="original">
                                            <span>{Currency}</span>
                                            <span>{addSeparator(LowListPrice)}</span>
                                        </div>
                                    )}
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="btn_note"
                onClick={(e) => {
                    e.stopPropagation();
                    handleClickList();
                    if (isMobile) dispatch(setTMInfoShow(true));
                }}
            >
                <span>{t('THSR.plan.viewPlan')}</span>
            </div>
            
        </div>
    );
};
export default TPlan;
